export const getValidationError = (
  value: number,
  isAmount: boolean,
  min?: number | string,
  max?: number | string
) => {
  if (!isAmount) {
    return {
      hasError: false,
      errorMessage: '',
    };
  }
  const hasMax = max !== undefined;
  const hasMin = min !== undefined;
  const maxNumber = hasMax ? Number.parseFloat(max?.toString()) : undefined;
  const minNumber = hasMin ? Number.parseFloat(min?.toString()) : undefined;
  const hasMaxNumber = typeof maxNumber === 'number';
  const hasMinNumber = typeof minNumber === 'number';

  if (
    hasMaxNumber &&
    hasMinNumber &&
    (value > maxNumber || value < minNumber)
  ) {
    return {
      hasError: true,
      errorMessage: `Please enter a value between ${min} and ${max}`,
    };
  }
  if (hasMaxNumber && value > maxNumber) {
    return {
      hasError: true,
      errorMessage: `Please enter a value less than ${maxNumber}`,
    };
  }
  if (hasMinNumber && value < minNumber) {
    return {
      hasError: true,
      errorMessage: `Please enter a value greater than ${minNumber}`,
    };
  }
  return {
    hasError: false,
    errorMessage: '',
  };
};
